export const HMIS_PATIENT_ID = "HMIS_PATIENT_CODE";
export const HMIS_OP_PATIENT_ID = "HMIS_PATIENT_OP_CODE";
export const HMIS_USERNAME = "HMIS_USERNAME";
export const HMIS_USERTIMEOUT = "HMIS_USERTIMEOUT";
